import { render, staticRenderFns } from "./changeIcon.vue?vue&type=template&id=52e87f27&scoped=true&"
import script from "./changeIcon.vue?vue&type=script&lang=js&"
export * from "./changeIcon.vue?vue&type=script&lang=js&"
import style0 from "./changeIcon.vue?vue&type=style&index=0&id=52e87f27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e87f27",
  null
  
)

export default component.exports